import { render, staticRenderFns } from "./ClientEmailView.vue?vue&type=template&id=25d45d25&scoped=true"
import script from "./ClientEmailView.vue?vue&type=script&lang=js"
export * from "./ClientEmailView.vue?vue&type=script&lang=js"
import style0 from "./ClientEmailView.vue?vue&type=style&index=0&id=25d45d25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d45d25",
  null
  
)

export default component.exports